/**
 * Composant Navbar qui bascule automatiquement entre la version originale et la nouvelle version
 * en fonction de la date définie.
 */

import React from 'react';
import { Navbar as NavbarOriginal } from './NavbarOriginal';
import { Navbar as NavbarNew } from './NavbarNew';

interface NavbarProps {
  /** Couleur de fond personnalisée (optionnel, défaut: 'white') */
  backgroundColor?: string;
  /** Afficher les animations (par défaut: true) */
  showAnimations?: boolean;
  /** Position CSS (optionnel, défaut: 'fixed') */
  position?: 'fixed' | 'relative' | 'sticky' | 'static';
  /** Position top (optionnel, défaut: 0) */
  top?: string | number;
  /** Mode sombre */
  isDark?: boolean;
  /** Variante de navigation */
  navigationVariant?: 'default' | 'landing';
}

export const Navbar: React.FC<NavbarProps> = (props) => {
  const now = new Date();
  const startDate = new Date('2025-11-22T00:00:00+01:00');
  const endDate = new Date('2025-11-30T23:59:59+01:00');

  // Debug: afficher les dates pour vérifier
  console.log('Navbar switch check:', {
    now: now.toISOString(),
    startDate: startDate.toISOString(),
    endDate: endDate.toISOString(),
    isBlackFridayPeriod: now >= startDate && now <= endDate,
    willShow: (now >= startDate && now <= endDate) ? 'NavbarNew (Black Friday)' : 'NavbarOriginal (Tarifs)'
  });

  // Afficher la NavbarNew (Black Friday) uniquement pendant la période promo
  if (now >= startDate && now <= endDate) {
    return <NavbarNew {...props} />;
  }

  return <NavbarOriginal {...props} />;
};
